import styles from "./demo-page.style.module.scss";
export interface Input {
  progress: number;
  buffered?: boolean;
  hydrateAll?: boolean;
  hydratePartial?: boolean;
  class?: Marko.HTML.Div["class"];
  label: Marko.HTML.Div["aria-label"];
  title: string;
  product: {
    name: string;
    price: string;
    image: string;
    description: string;
    review: {
      title: string;
      description: string;
    };
  };
}

const/progress=(
  input.buffered ? Math.floor(input.progress / 0.9) : input.progress / 0.9
)

div role="img" aria-label=input.label class=styles.wrapper
  div
    ,aria-hidden="true"
    ,class=[
      styles.container,
      {
        [styles.hydrateAll]: input.hydrateAll,
        [styles.hydratePartial]: input.hydratePartial,
      },
    ]
    div
      ,class=[
        styles.delay,
        {
          [styles.loading]: progress < 0.1,
        },
        styles.header,
      ]
      ,style="--delay: 1"
      div class=[styles.link, styles.delay] style="--delay: 2" -- All Products
      div class=[styles.logo, styles.delay] style="--delay: 3" -- BuyItNow
      div
        ,class=[styles.cart, styles.delay, styles.hydrated]
        ,style="--delay: 4" -- Cart (0)
    div
      ,class=[
        styles.product,
        styles.delay,
        {
          [styles.loading]: progress < 0.14,
        },
      ]
      ,style="--delay: 5"
      img
        ,alt=""
        ,src=(input.product.image)
        ,class=[
          styles.image,
          {
            [styles.lowRes]:
              progress < 0.6 || (input.buffered && input.progress < 1),
          },
        ]
      div class=[styles.description, styles.delay] style="--delay: 6"
        span class=styles.descriptionTitle --
          ${input.product.name} - $${input.product.price}
        div
          ,class=[styles.descriptionButton, styles.delay, styles.hydrated]
          ,style="--delay: 7" -- Add to Cart
        span class=styles.descriptionText -- ${input.product.description}
    div
      ,class=[
        styles.review,
        styles.delay,
        {
          [styles.loading]: progress < 0.8,
        },
      ]
      ,style="--delay: 8"
      div class=[styles.rating, styles.delay] style="--delay: 9" -- ★★★★☆
      span class=styles.descriptionText
        strong -- ${input.product.review.title}
        -- ${" " + input.product.review.description}
    div
      ,class=[
        styles.footer,
        styles.delay,
        {
          [styles.loading]: progress < 0.1,
        },
      ]
      ,style="--delay: 12"
      div class=styles.delay style="--delay: 13" -- About
      div class=styles.delay style="--delay: 14" -- Security
      div class=styles.delay style="--delay: 15" -- Policies
      div class=styles.delay style="--delay: 16" -- Help
      div class=styles.delay style="--delay: 17" -- Sitemap
  if=input.buffered || input.hydrateAll
    div class=styles.title -- ${input.title}
  else
    div class=[styles.title, styles.titleMarko]
      img src="/assets/logomark.svg" alt=""
      -- ${" "}${input.title}
